import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequirePhone = () => {
  const { userData, loading } = useAuth();

  if (loading) return null;

  // TODO: 테스트용 - 전화번호 체크 우회
  return <Outlet />;

  // if (!userData?.phoneE164) {
  //   return <Navigate to="/link-phone" replace />;
  // }
  // return <Outlet />;
};

export default RequirePhone;
